import { connect } from "react-redux";
import Summary from "./summary";
import { onEdit, onDelete } from "../actions";

const mapStateToProps = ({ sites, organisations, profile }) => ({
	site: sites.currentSite,
	organisationId:
		organisations?.currentOrganisation?.id ||
		organisations?.currentOrganisation ||
		"",
	role: profile.role,
});

const mapDispatchToProps = { onEdit, onDelete };

export default connect(mapStateToProps, mapDispatchToProps)(Summary);
